import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-site-details-dialog',
  templateUrl: './site-details-dialog.component.html',
  styleUrls: ['./site-details-dialog.component.css'],
  standalone: false
})
export class SiteDetailsDialogComponent implements OnInit {
  displayedColumns: string[] = ['id','potentialName', 'potentialId', 'siteType'];
  dataSource: MatTableDataSource<{ key: string; value: any }>;
  constructor( public dialogRef: MatDialogRef<SiteDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
     }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.data);
  }

  onClose(): void {
    this.dialogRef.close();
  }
  }

